import type {UseComboboxGetLabelPropsReturnValue} from 'downshift';
import {memo} from 'react';

import * as styles from './style.module.scss';

type LabelProps = {
  label: string;
} & UseComboboxGetLabelPropsReturnValue;

const Label = memo(function Label({label, ...props}: LabelProps) {
  return (
    <label {...props} className={styles.label}>
      {label}
    </label>
  );
});

export {Label};
